import { render } from "./SabreAirAvail.vue?vue&type=template&id=2581cd7a&scoped=true"
import script from "./SabreAirAvail.vue?vue&type=script&lang=js"
export * from "./SabreAirAvail.vue?vue&type=script&lang=js"

import "./SabreAirAvail.vue?vue&type=style&index=0&id=2581cd7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2581cd7a"]])

export default __exports__